import React from "react";
import { useParams } from "react-router-dom";
import cn from "classnames";
import styles from "./Post.module.sass";
import Icon from "../../../components/Icon";
import Share from "../../../components/Share";
import SEOHead from "../../../components/SEOHead";
import Breadcrumbs from "../../../components/Breadcrumbs";

import { useArticle } from "../../../hooks/useArticles";
import { useArticleSEO } from "../../../hooks/useArticleSEO";
import { formatDate, getPocketBaseFileUrl } from "../../../utils/formatters";

const Post = ({ useId = false }) => {
  const params = useParams();
  // Récupérer soit le slug soit l'id selon la route
  const identifier = useId ? params.id : params.slug;
  const { article, loading, error } = useArticle(identifier);
  const seoData = useArticleSEO(article);

  if (loading) {
    return (
      <div className={cn("section", styles.section)}>
        <div className={cn("container", styles.container)}>
          <div className={styles.head}>
            <h1 className={cn("h1", styles.title)}>Chargement...</h1>
          </div>
        </div>
      </div>
    );
  }

  if (error || !article) {
    return (
      <div className={cn("section", styles.section)}>
        <div className={cn("container", styles.container)}>
          <div className={styles.head}>
            <h1 className={cn("h1", styles.title)}>
              {error || 'Article non trouvé'}
            </h1>
          </div>
        </div>
      </div>
    );
  }

  // Breadcrumbs personnalisés pour l'article
  const breadcrumbItems = [
    { name: 'Accueil', path: '/' },
    { name: 'Actualités', path: '/actualites' },
    { name: article.title, path: `/article/${article.slug || article.id}` }
  ];

  return (
    <>
      <SEOHead {...seoData} />
      <div className={cn("section", styles.section)}>
        <div className={cn("container", styles.container)}>
          <Breadcrumbs items={breadcrumbItems} />
        <div className={styles.head}>
          <h1 className={cn("h1", styles.title)}>
            {article.title}
          </h1>
          <Share 
            className={styles.shareButton} 
            title={article.title}
            description={article.excerpt}
          />
        </div>
        <div className={styles.row}>
          <div className={styles.col}>
            <div className={styles.preview}>
              <img 
                src={getPocketBaseFileUrl(article, article.cover_image)} 
                alt={article.title}
                onError={(e) => {
                  e.target.src = "/images/content/history-pic.png";
                }}
              />
            </div>
          </div>
          <div className={styles.col}>
            <div className={styles.meta}>
              {article.expand?.category && (
                <>
                  <span className={styles.bold}>
                    {article.expand.category.name}
                  </span>
                  <span> - </span>
                </>
              )}
              <span className={styles.date}>
                {formatDate(article.created, { year: 'numeric', month: 'long', day: 'numeric' })}
              </span>
            </div>
            
            {article.excerpt && (
              <div className={styles.info} style={{ marginTop: '20px', marginBottom: '20px' }}>
                {article.excerpt}
              </div>
            )}
            
            {article.cover_image && (
              <div className={styles.preview}>
                <img 
                  src={getPocketBaseFileUrl(article, article.cover_image)} 
                  alt={article.title}
                  onError={(e) => {
                    e.target.src = "/images/content/post-pic.png";
                  }}
                />
              </div>
            )}
            
            <div className={styles.content} style={{ marginTop: '30px' }}>
              {article.content ? (
                <div dangerouslySetInnerHTML={{ __html: article.content }} />
              ) : (
                <p>Contenu de l'article non disponible.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Post;
